import { green } from '@ant-design/colors'
import { faKey } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Card, Col, Form, Input, Row, Space, Switch } from 'antd'
import { useContext, useState } from 'react'
import UsersPageContext from '../UsersPageContext'
import { useUpdatePasswordMutation } from '../usersQueries'

const PasswordUpdateSection = () => {
  const { state: { email } } = useContext(UsersPageContext)

  const [isPasswordVisible, setIsPasswordVisible] = useState(false)
  const [newPassword, setNewPassword] = useState('')
  const [confirmNewPassword, setConfirmNewPassword] = useState('')

  const updatePasswordMutation = useUpdatePasswordMutation()

  const updatePassword = () => {
    updatePasswordMutation.mutate({ email, newPassword, confirmNewPassword })
    setNewPassword('')
    setConfirmNewPassword('')
  }

  return <Card title={<Space><FontAwesomeIcon icon={faKey} />Update User Password</Space>} bordered={false}>
    <p>
      The password must contain at least one uppercase letter, one lowercase letter, one special character, and be at least 8 characters long.
    </p>
    <Row gutter={16}>
      <Col span={12}>
        <Form.Item label="New Password">
          <Input 
            type={isPasswordVisible ? 'text' : 'password'} 
            placeholder="Enter new password..." 
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item label="Confirm New Password">
          <Input 
            type={isPasswordVisible ? 'text' : 'password'} 
            placeholder="Confirm new password..." 
            value={confirmNewPassword}
            onChange={(e) => setConfirmNewPassword(e.target.value)}
          />
        </Form.Item>
      </Col>
    </Row>
    <Form.Item>
      <Switch checked={isPasswordVisible} onChange={setIsPasswordVisible} /> Show passwords
    </Form.Item>
    <Button 
      type='primary' 
      style={{ backgroundColor: green.primary}} 
      icon={<FontAwesomeIcon icon={faKey} />}
      onClick={updatePassword}
      disabled={!newPassword || !confirmNewPassword}
    >
      Update Password
    </Button>
  </Card>
}

export default PasswordUpdateSection